<template>
  <div class="grouping pointer">
    <div class="AochenTop">
      <div class="top">
        <div class="fanhui" @click="getBack()">
          <img class="img1" src="@/assets/icons/fanhui.png" alt="" />
        </div>
        <div class="title">
          <p>分组管理</p>
        </div>
        <button
          class="title_btn"
          @click="(addShow = true), (popTitle = '新增分组')"
        >
          新增分组
        </button>
      </div>
    </div>
    <div class="contentBox">
      <div class="card" v-for="item in cardList" :key="item.id">
        <div class="information" @click="item.showStatus = !item.showStatus">
          <div class="mationLeft">
            <div class="nameTop">
              <div>
                {{ item.groupName }}
              </div>
              <div>
                <img
                  v-show="item.showStatus"
                  src="@/assets/imgs/groupingTop.png"
                  alt=""
                />
                <img
                  v-show="!item.showStatus"
                  src="@/assets/imgs/groupingBottom.png"
                  alt=""
                />
              </div>
            </div>
            <div class="numBottom">共{{ item.instanceList.length }}台</div>
          </div>
          <div class="mationRight" v-if="item.groupName != '默认分组'">
            <img
              class="rightImg1"
              src="@/assets/icons/newName.png"
              alt=""
              @click.stop="redact(item.id, item.groupName)"
            />
            <img
              class="rightImg2"
              src="@/assets/icons/deldet.png"
              alt=""
              @click.stop="groupingDelete(item.id)"
            />
          </div>
        </div>
        <div
          class="listEquipment"
          v-if="item.showStatus && item.instanceList.length > 0"
        >
          <div
            v-for="list in item.instanceList"
            :key="list.id"
            class="listNape"
          >
            <div class="shebei_title">
              <div class="shebei_content">
                <p class="p1">
                  <span class="deviceType">{{
                    getDeviceType(list.vipCode, list.deviceVersionCode)
                  }}</span>
                  {{ list.instanceName }}
                </p>
                <div class="p2">
                  <img class="idIcon" src="@/assets/imgs/ID.png" alt="" />
                  <p class="id">{{ list.instanceId }}</p>
                </div>
              </div>
              <div class="instanceItem">
                剩余时间：{{ formatSeconds(list.expireSeconds) }}
              </div>
            </div>
            <div class="check">
              <van-checkbox-group
                v-model="result"
                direction="horizontal"
                checked-color="#8572eb"
              >
                <van-checkbox :name="list.id" ref="checkboxes" />
              </van-checkbox-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="base">
      <div class="baseText">已选择{{ result.length }}台云手机</div>
      <button class="baseBut button" @click="movement">移入分组</button>
    </div>
    <van-popup
      v-model="addShow"
      position="bottom"
      closeable
      round
      :style="{ height: '240px' }"
    >
      <div class="addGroupingPopup">
        <div class="baseTiele">{{ popTitle }}</div>
        <van-field
          maxlength="8"
          v-model="addValue"
          placeholder="请输入分组名称"
        />
        <div class="AddOperate">
          <button class="button cancelAdd" @click="addShow = false">
            取消
          </button>
          <button class="button affirmAdd" @click="addAffirm">确认</button>
        </div>
      </div>
    </van-popup>
    <van-dialog v-model="deleteShow" :showConfirmButton="false" width="280px">
      <div class="deleteTitle">提示</div>
      <div class="hintText">确定要删除分组吗？</div>
      <div class="deleteOperate">
        <button class="button deleteCancel" @click="deleteShow = false">
          取消
        </button>
        <button class="button deleteAffirm" @click="affirmDelete">确认</button>
      </div>
    </van-dialog>
  </div>
</template>
    
    <script>
import { Toast } from "vant";
import { groupAdd, groupDelete, groupUpdate } from "@/api/instance";
import { groupList } from "@/api/index";
import buyCode from "@/utils/buyCode";
export default {
  name: "grouping",
  components: {},
  data() {
    return {
      cardList: [],
      addShow: false,
      deleteShow: false,
      addValue: "",
      popTitle: "",
      deleteid: null,
      groupId: null,
      result: [],
    };
  },
  mounted() {
    this.getGroupList();
  },
  methods: {
    // 获取分组信息
    getGroupList() {
      groupList().then((res) => {
        if (res.code == 200) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].showStatus = false;
          }
          let arr = res.data;
          for (let i = 0; i < arr.length; i++) {
            for (let k = 0; k < arr[i].instanceList.length; k++) {
              if (arr[i].instanceList[k].overSoldDevice) {
                arr[i].instanceList.splice(k, 1);
              }
            }
          }
          this.cardList = arr;
        } else {
          Toast(res.msg);
        }
      });
    },
    // 回退
    getBack() {
      this.$router.go(-1);
    },
    redact(id, name) {
      this.addShow = true;
      this.popTitle = "编辑分组标题";
      this.groupId = id;
      this.addValue = name;
    },
    // 新增分组
    addAffirm() {
      if (this.popTitle == "新增分组") {
        groupAdd({ groupName: this.addValue }).then((res) => {
          if (res.code == 200) {
            this.getGroupList();
            this.addShow = false;
            this.addValue = "";
          }
        });
      } else {
        groupUpdate({ groupName: this.addValue, id: this.groupId }).then(
          (res) => {
            if (res.code == 200) {
              this.getGroupList();
              this.addShow = false;
              this.addValue = "";
            } else {
              Toast(res.msg);
            }
          }
        );
      }
    },
    // 删除分组
    groupingDelete(id) {
      this.deleteShow = true;
      this.deleteid = id;
    },
    affirmDelete() {
      groupDelete({
        ids: [this.deleteid],
      }).then((res) => {
        if (res.code == 200) {
          this.getGroupList();
          this.deleteShow = false;
        } else {
          Toast(res.msg);
        }
      });
    },
    movement() {
      if (this.result.length > 0) {
        this.$router.push({
          name: "SelectGrop",
          params: {
            results: this.result,
          },
        });
      } else {
        Toast("请选择云手机");
      }
    },
    formatSeconds(totalSeconds) {
      // 计算各时间单位
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      // 生成单位映射
      const units = ["天", "小时", "分"];
      // 构建结果数组
      const parts = [];
      if (days > 0) parts.push(`${days}${units[0]}`);
      if (hours > 0) parts.push(`${hours}${units[1]}`);
      if (minutes > 0 && totalSeconds < 86400)
        parts.push(`${minutes}${units[2]}`);
      // 处理全0情况
      if (parts.length === 0) return `0${units[3]}`;
      return parts.join("");
    },
  },
  computed: {
    getDeviceType: {
      get() {
        return function (vipCode, deviceVersionCode) {
          let item = buyCode.deviceIconOptions.find(
            (item) =>
              item.vipCode == vipCode &&
              item.deviceVersionCode == deviceVersionCode
          );
          if (item) {
            return item.deviceType;
          } else {
            if (deviceVersionCode) {
              return `定制${deviceVersionCode.substring(1)}`;
            } else {
              return "";
            }
          }
        };
      },
    },
  },
};
</script>
    
  <style lang="less" scoped>
.grouping {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
}
.button {
  border: none;
  background: none;
}
.AochenTop {
  max-width: 414px;
  top: 0;
  // left: 0;
  width: 100%;
  height: 50px;
  z-index: 1001;
  font-size: 12px;
}
.top {
  position: relative;
  height: 50px;
  display: flex;
  align-items: center;
  .fanhui {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      //   margin-top: 13px;
      //   width: 17px;
      height: 17px;
    }
    .img1 {
      width: 17px;
    }
  }
  .title {
    flex: 1;
    p {
      // margin-top: 30px;
      font-size: 16px;
      font-weight: 500;
    }
  }
  .title_btn {
    font-size: 15px;
    font-weight: 400;
    color: #886df3;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    // width: 58px;
    border: none;
    background: none;
  }
}
.contentBox {
  padding: 12px 10px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  touch-action: manipulation;
  scrollbar-width: none;
  .card {
    margin-top: 10px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 13px 12px 13px 16px;
    border-radius: 10px;
    .information {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .mationLeft {
        .nameTop {
          display: flex;
          font-size: 17px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          color: #333333;
          margin-bottom: 4px;
          img {
            width: 20px;
            margin-top: 2px;
          }
        }
        .numBottom {
          font-size: 13px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          color: #999999;
          text-align: left;
        }
      }
      .mationRight {
        height: 24px;
        img {
          width: 24px;
        }
        .rightImg1 {
          margin-right: 12px;
        }
      }
    }
    .listEquipment:before {
      content: "";
      width: 319px;
      border: 1px solid #ededed;
      height: 0px;
      position: absolute;
      top: -4px;
      left: 0;
    }
    .listEquipment {
      position: relative;
      margin-top: 17px;
      .listNape {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 0 0 0;
      }
    }
  }
  .shebei_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 8px;
    flex: 1;
    img {
      width: 40px;
      height: 40px;
      border-radius: 20px;
    }
    .shebei_content {
      // margin-left: 16px;
      text-align: left;
      p {
        margin: 0;
        height: 22px;
        font-size: 13px;
        font-weight: 400;
        color: #999999;
        line-height: 22px;
      }
      .p1 {
        font-weight: 500;
        font-size: 15px;
        color: #505465;
      }
      .p2 {
        display: flex;
        align-items: center;
        .idIcon {
          width: 18px;
          height: 17px;
          margin-right: 4px;
        }
        .id {
          font-weight: 500;
          font-size: 10px;
          color: #b8bdcc;
        }
      }
    }
    .instanceItem {
      font-weight: 400;
      font-size: 13px;
      color: #a9adb6;
    }
  }
  .check {
    margin-right: 2px;
  }
}
.base {
  max-width: 414px;
  bottom: 0;
  width: 100%;
  height: 60px;
  background: #ffffff;
  box-shadow: 0px -1px 2px 0px rgba(153, 153, 153, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 14px;
  .baseText {
    font-size: 15px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #666;
  }
  .baseBut {
    width: 120px;
    height: 44px;
    background: #886df3;
    border-radius: 26px;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
  }
}
.addGroupingPopup {
  .baseTiele {
    font-size: 17px;
    font-weight: 500;
    color: #333;
    margin-top: 15px;
  }
  .van-cell::after {
    display: none;
  }
  /deep/ .van-field__control {
    width: 315px;
    height: 50px;
    background: #f5f5f5;
    border-radius: 8px;
    border: 1px solid #ebebeb;
    margin: 24px auto 0 auto;
    text-indent: 16px;
  }
  .AddOperate {
    margin: 0 auto;
    font-size: 17px;
    margin-top: 30px;
    .cancelAdd {
      width: 150px;
      height: 48px;
      border-radius: 26px;
      border: 1px solid #999;
      font-weight: 500;
      color: #666;
      margin-right: 15px;
    }
    .affirmAdd {
      width: 150px;
      height: 48px;
      background: #886df3;
      border-radius: 26px;
      font-weight: 500;
      color: #fff;
    }
  }
}
.deleteTitle {
  font-size: 18px;
  font-weight: 400;
  color: #000;
  margin-top: 16px;
}
.hintText {
  font-size: 15px;
  font-weight: 400;
  color: #666;
  margin-top: 16px;
}
.deleteOperate {
  margin: 22px auto 18px auto;
  .deleteCancel {
    width: 108px;
    height: 40px;
    border-radius: 20px;
    border: 1px solid #999999;
    font-size: 15px;
    font-weight: 400;
    color: #333;
    margin-right: 12px;
  }
  .deleteAffirm {
    width: 108px;
    height: 40px;
    background: #886df3;
    border-radius: 20px;
    font-size: 15px;
    font-weight: 400;
    color: #fff;
  }
}
</style>